import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "advanced-filters" }
const _hoisted_2 = {
  key: 0,
  class: "filter-section"
}
const _hoisted_3 = { class: "filter-section__filters" }
const _hoisted_4 = {
  key: 1,
  class: "filter-section"
}
const _hoisted_5 = {
  key: 0,
  class: "filter-section__filters"
}
const _hoisted_6 = {
  key: 2,
  class: "filter-section__filters"
}
const _hoisted_7 = {
  key: 0,
  class: "filter-section__filters"
}

import { useStore } from "../../stores/store";
import { ref } from 'vue';
import DropdownFilter from '@/components/filter/DropdownFilter.vue';
import IntervalFilter from '@/components/filter/IntervalFilter.vue';
import { useFilterStore } from "../../stores/filterStore";

export default /*@__PURE__*/_defineComponent({
  __name: 'AdvancedFilter',
  setup(__props) {

const filterStore = useFilterStore();
const showConstructionFilters = ref(true);
const showPropertiesFilters = ref(true);

const minimizeFilters = () => {
    filterStore.showAdvancedFilter = !filterStore.showAdvancedFilter;
}

const minimizeConstructionFilters = () => {
    showConstructionFilters.value = !showConstructionFilters.value;
}

const minimizePropertiesFilters = () => {
    showPropertiesFilters.value = !showPropertiesFilters.value;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "advanced-filters__button button button--clear",
      onClick: minimizeFilters
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "filter-heading filter-heading--simple" }, "Avancerad filtrering", -1 /* HOISTED */)),
      _createElementVNode("span", {
        class: _normalizeClass(["icon", { 'icon--minus': _unref(filterStore).showAdvancedFilter, 'icon--plus': !_unref(filterStore).showAdvancedFilter }])
      }, null, 2 /* CLASS */)
    ]),
    (_unref(filterStore).showAdvancedFilter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(DropdownFilter, {
              dataKey: "navalBattles",
              placeholder: "Välj händelse",
              title: "Deltog i"
            }),
            _createVNode(IntervalFilter, {
              dataKey: "suspension",
              title: "Avslut/Avfört ur flottan"
            }),
            _createVNode(DropdownFilter, {
              dataKey: "fates",
              placeholder: "Välj typ av avslut",
              title: "Typ av avslut"
            }),
            _createVNode(DropdownFilter, {
              dataKey: "constructionSite",
              placeholder: "Välj byggnadsort",
              title: "Byggnadsort"
            })
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_unref(filterStore).showAdvancedFilter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "advanced-filters__button advanced-filters__button--sub button button--clear",
            onClick: minimizeConstructionFilters
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "filter-heading filter-heading--simple" }, "Konstruktion", -1 /* HOISTED */)),
            _createElementVNode("span", {
              class: _normalizeClass(["icon", { 'icon--minus': showConstructionFilters.value, 'icon--plus': !showConstructionFilters.value }])
            }, null, 2 /* CLASS */)
          ]),
          (showConstructionFilters.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(DropdownFilter, {
                  dataKey: "constructor",
                  placeholder: "Välj byggmästare",
                  title: "Byggmästare"
                }),
                _createCommentVNode(" <DropdownFilter dataKey=\"woodType\" placeholder=\"Välj träslag\" title=\"Träslag\" /> Temporary "),
                _createVNode(DropdownFilter, {
                  dataKey: "status",
                  placeholder: "Lägesbestämd",
                  title: "Lägesbestämd"
                })
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_unref(filterStore).showAdvancedFilter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "advanced-filters__button advanced-filters__button--sub button button--clear",
            onClick: minimizePropertiesFilters
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "filter-heading filter-heading--simple" }, "Egenskaper", -1 /* HOISTED */)),
            _createElementVNode("span", {
              class: _normalizeClass(["icon", { 'icon--minus': showPropertiesFilters.value, 'icon--plus': !showPropertiesFilters.value }])
            }, null, 2 /* CLASS */)
          ]),
          (showPropertiesFilters.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(IntervalFilter, {
                  dataKey: "length",
                  title: "Längd"
                }),
                _createVNode(IntervalFilter, {
                  dataKey: "width",
                  title: "Bredd"
                }),
                _createVNode(IntervalFilter, {
                  dataKey: "numberOfCannons",
                  title: "Kanoner"
                }),
                _createVNode(IntervalFilter, {
                  dataKey: "numberOfSailors",
                  title: "Sjöfolk"
                }),
                _createVNode(IntervalFilter, {
                  dataKey: "numberOfSoldiers",
                  title: "Soldater"
                }),
                _createVNode(IntervalFilter, {
                  dataKey: "crewTotal",
                  title: "Total besättning"
                })
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})